import { ReactNode } from "react";
import { AsyncLoader } from "../../common-loader/hooks/useAsyncLoader";
import { isLoadingClassName } from "../../common/miscellaneous/isLoadingClassName";
import { LoaderContextA } from "../miscellaneous/LoaderContextA";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type LoaderProviderProps<T> = {
  readonly children: ReactNode;
  readonly loader: AsyncLoader<T>;
  readonly glow: boolean;
};

export function LoaderProviderA<T>(props: LoaderProviderProps<T>) {
  return (
    <LoaderContextA.Provider value={{ loader: props.loader }}>
      {props.glow ? (
        <span className={isLoadingClassName(props.loader, "a")}>
          {props.children}
        </span>
      ) : (
        props.children
      )}
    </LoaderContextA.Provider>
  );
}
